const pad = (value: number) => String(value).padStart(2, '0')

function session(startHour: number, startMinute: number, endHour: number, endMinute: number): string[] {
  const result: string[] = []
  const start = startHour * 60 + startMinute
  const end = endHour * 60 + endMinute
  for (let minute = start; minute <= end; minute += 1) {
    result.push(`${pad(Math.floor(minute / 60))}:${pad(minute % 60)}`)
  }
  return result
}

export function createTradingTimes(): string[] {
  return [...session(9, 30, 11, 30), ...session(13, 0, 15, 0)]
}

export function formatTradingDate(isoDate: string): string {
  const [, month, day] = isoDate.split('-')
  return `${month}月${day}日`
}

export function findTimeIndex(times: string[], target: string): number {
  const index = times.indexOf(target)
  return index < 0 ? 0 : index
}
